import SpellsFilterArrayFilter from "./SpellsFilterArrayFilter";

export default SpellsFilterArrayFilter;
export { SpellsFilterArrayFilter };
